<template>
  <div class="page-wrapper">
    <div class="fullscreen-image" style="background-image:url('/static/img/login-bg.jpg')">
      <div class="logo">
        <img src="/static/img/logo-white.svg"/>
      </div>
      <div class="center-container">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h4>KOKORO Shop Manager</h4>

            </div>
          </div>

          <div class="row form-group">
            <div class="col-12">
              <input type="email" class="form-control text-center" v-model="email" placeholder="Username" @keyup.enter="signIn"/>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-12">
              <input type="password" class="form-control text-center" v-model="password" placeholder="비밀번호" @keyup.enter="signIn"/>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-12 text-left">
              <input type="checkbox" v-model="autoLogin"/> Auto Login
            </div>
          </div>
          <div class="row form-group">
            <div class="col-12">
              <button type="button" class="btn btn-primary form-control" v-on:click="signIn">로그인</button>
            </div>
          </div>
          <div class="row form-group" v-if="errorMessage !== null && errorMessage.length > 0">
            <div class="col-12" style="color: red; font-size: 1.2rem;">
              {{errorMessage}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import EventBus from '../api/event-bus.js';
    import {userSignIn, getMenuItems} from '../api/user'
    import {showDialog} from "../api/utils";

    export default {
        name: "Login",
        data() {
            return {
                mode:0,
                email:'',
                password:'',
                newEmail:'',
                newName:'',
                newPwd:'',
                newPwd2:'',
                newLevel: 0,
                autoLogin: false,
                errorMessage:null,

            }
        },
        created() {
        },
        mounted() {
          this.onStart();
        },
        methods: {
            onStart: function() {
              // console.log("autoLogin " + localStorage.getItem("autoLogin"));
              // console.log("email " + localStorage.getItem("email"));
              // console.log("password " + localStorage.getItem("password"));
              if(localStorage.getItem("autoLogin") !== undefined && localStorage.getItem("autoLogin") !== null) {
                this.$data.autoLogin = localStorage.getItem("autoLogin");
              }
              if(this.$data.autoLogin === 'true') {
                // console.log("Auto log in is set");

                // if(localStorage.getItem("email") !== undefined && localStorage.getItem("email") !== null) {
                if(localStorage.getItem("email") != null) {
                  // console.log("email read ")
                  this.$data.email = localStorage.getItem("email");

                }
                if(localStorage.getItem("password") !== undefined && localStorage.getItem("password") !== null) {
                  this.$data.password = localStorage.getItem("password");
                }

                // console.log("Now set " + this.$data.email + " " + this.$data.password);
                if(this.$data.email !== undefined && this.$data.email !== null && this.$data.email.length > 0
                &&  this.$data.password !== undefined && this.$data.password !== null && this.$data.password.length > 0) {
                  this.signIn();
                }
              }

            },
            signIn: function() {
                this.$data.errorMessage = null;
                let self = this;
                if(this.$data.email === null || this.$data.email.length === 0) {
                  return;
                }
              this.$data.email = this.$data.email.trim();
                EventBus.$emit("showLoading", true);
                userSignIn(this.$data.email, this.$data.password)
                    .then(function(data){
                        EventBus.$emit("showLoading", false);
                        // console.log("Successful signin " + data.success);
                        // console.log(data)
                        if(data.success == true) {
                            if(data.item.type !== 'ROLE_MANAGER' && data.item.type !== 'ROLE_ADMIN' && data.item.type !== 'ROLE_STAFF' && data.item.type !== 'ROLE_MALL_MANAGER' ) {
                              localStorage.removeItem("JSTOKEN");
                              localStorage.removeItem("email");
                              localStorage.removeItem("id");
                              localStorage.removeItem("autoLogin");
                              EventBus.$emit("logon", false);
                              self.$data.errorMessage = "No access";
                              return;
                            }
                            // console.log("Successful signin");
                            localStorage.setItem("JSTOKEN", data.item.token);
                            localStorage.setItem("email", data.item.email);
                            localStorage.setItem("id", data.item.id);
                            localStorage.setItem("autoLogin", self.$data.autoLogin);
                            console.log("auto login " + self.$data.autoLogin);
                            if(self.$data.autoLogin == true || self.$data.autoLogin === 'true') {
                              // console.log("auto login save password");
                              localStorage.setItem("password", self.$data.password);
                            }
                            EventBus.$emit("logon", true);
                            if(data.item.type === 'ROLE_MALL_MANAGER') {
                              self.$router.push('/commerce');
                            } else {
                              if(localStorage.getItem("lastPage") !== null) {
                                self.$router.push(localStorage.getItem("lastPage"));
                              }  else {
                                self.$router.push('/orders');
                              }
                            }
                        } else {
                            localStorage.removeItem("JSTOKEN");
                            localStorage.removeItem("email");
                            localStorage.removeItem("id");
                            localStorage.removeItem("autoLogin");
                            EventBus.$emit("logon", false);
                            self.$data.errorMessage = data.message;
                        }
                    })
                    .catch(function(err){
                        EventBus.$emit("showLoading", false);
                        console.log("Error " + err);
                        console.log(err.response);
                        EventBus.$emit("logon", false);
                    })
            }
        }
    }
</script>

<style lang="css" scoped>
  .section-padding-top {
    padding-top:50px;
  }
  .center-container {
    min-width: 300px;
    padding:10px;
    background: white;
    border-radius: 10px;
  }
  .logo {
    max-width: 400px;
    position: absolute;
    top:50px;
    left:50%;
    transform: translateX(-50%);

  }
  .logo > img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue